import { computed, reactive } from "vue";
import { BOOK_TYPE } from "./js/book_define/book_type";
import {
    AFILE_DISABLE_TOOLS,
    AFILE_MOVIE_DISABLE_TOOLS,
    DISABLE_TOOLS_A,
    WHITEBOARD_DISABLE_TOOLS,
    IFRAME_DISABLE_TOOLS,
    GRAPHIC_BOARD_DISABLE_TOOLS,
    STAMP_DISABLE_TOOLS
} from './js/toolbar/tools';
import { PLAYER_TYPE } from "./js/bookItems/sound/player_type";
import { TURN_PAGE_TYPE } from './js/book_define/turn_page_type';
import { ROUND_DECIMAL } from "./js/common/round_decimal";
import { VIEW_TYPE, WEB_BROWSER } from "./js/view_type";

export const store = reactive({
    nowView: VIEW_TYPE.PC,
    // web版才要額外判斷瀏覽器
    nowWebBrowser: WEB_BROWSER.NONE,
    nowBook: BOOK_TYPE.BOOK,
    nowPage: 0,
    pageContent: null,
    nowDirectoryTag: "",
    directoryMap: {},
    nowTool: "selection",
    toggleTool: {},
    toolbarHeight: 0,
    toolbarWidth: 0,
    pageLeft: 0,
    pageRight: 0,
    pageWidth: 0,
    pageHeight: 0,
    nowLogName: "",
    editingToolBar: false,
    directoryContent: null,
    tools: [],
    disabledTools: [],
    cursorSetting: {},
    mergeToCloud: false,
    fetchCloudRecord: false,
    updateUserRecord: false,
    currentSaveRecordName: "",
    globalPaintData: { width: 0, height: 0, margin: 0 },
    windowScale: 1,
    singlePageTrigger: false,
    singlePageMode: false,
    singlePageIndex: 0,
    bookPageScale: { x: 1, y: 1 },
    currentBookPageScale: { x: 1, y: 1 },
    toolMap: new Map(),
    prevTool: "selection",
    playerType: PLAYER_TYPE.FULL,
    isPenDrag: false,
    dragIconPoint: {},
    currentBookPage: 0,
    currentStudyPage: 0,
    turnPageType: TURN_PAGE_TYPE.TURN_RIGHT,
    windowDevicePixelRatio: 1,
    movieVolume: 50,
    baseSize: {
        width: 1457,
        height: 1017
    },
    contentScale: 1,
    contentScaleX: 1,
    contentScaleY: 1,
    horizonContainerWidth: 1457,
    verticalContainerWidth: 1647,
    canTurnPage: true,
    canTouchAction: false,
    stampCustomPage: null,
    stampCustomIndex: null,
    appContent: null,
    onlyRead: false,

    // 紀錄資料夾權限
    folderPermissions: { f: false, w: false, r: false, x: false },

    initPageContent(content) {
        this.pageContent = content;
    },
    setNowPage(page) {
        this.nowPage = page;
    },
    setToolToggle(key, isToggle) {
        this.toggleTool[key] = isToggle;
    },
    setDirectoryData(content) {
        this.directoryContent = content;
    },
    setGlobalPaintData(globalPaintData) {
        this.globalPaintData = globalPaintData;
    },
    setWindowScale(windowScale) {
        this.windowScale = windowScale;
    },
    switchSinglePageTrigger(trigger) {
        this.singlePageTrigger = trigger;
    },
    setSinglePageMode(isSinglePage) {
        this.singlePageMode = isSinglePage;
    },
    setSinglePageIndex(index) {
        this.singlePageIndex = index;
    },
    clearDisabledTools() {
        this.disabledTools = [];
    },
    setAFileDisabledTools() {
        this.disabledTools = AFILE_DISABLE_TOOLS;
    },
    setAFileMovieDisabledTools() {
        this.disabledTools = AFILE_MOVIE_DISABLE_TOOLS;
    },
    setWhiteboardDisabledTools() {
        this.disabledTools = WHITEBOARD_DISABLE_TOOLS;
    },
    setIframeDisabledTools() {
        this.disabledTools = IFRAME_DISABLE_TOOLS;
    },
    setStampDisabledTools() {
        this.disabledTools = STAMP_DISABLE_TOOLS;
    },
    setGraphicDisabledTools() {
        this.disabledTools = GRAPHIC_BOARD_DISABLE_TOOLS
    },
    setBookPageScale(x, y) {
        this.bookPageScale.x = x;
        this.bookPageScale.y = y;
    },
    setPreviousTool(tool) {
        this.prevTool = tool;
    },
    setDragIconPoint(x, y) {
        this.dragIconPoint.x = x;
        this.dragIconPoint.y = y;
    },
    setTurnPageType(type) {
        this.turnPageType = type;
    },
    get contentSize() {
        const contentRect = this.appContent ? this.appContent.getBoundingClientRect() : {x: 0, y: 0, width: 0, height: 0};

        return {
            x: ROUND_DECIMAL(contentRect.x, 2),
            y: ROUND_DECIMAL(contentRect.y, 2),
            width: ROUND_DECIMAL(contentRect.width, 2),
            height: ROUND_DECIMAL(contentRect.height, 2)
        }
    },
    get currentPaintSaveKey() {
        return `${this.nowBook}:${this.pageContent[this.nowBook][this.nowPage].pageName}`
    }
});

export const afileBorder = computed(() => {
    return 64;
})
export const afileBorderBottom = computed(() => {
    return 80;
})

export const originBookSize = reactive({
    width: 0,
    height: 0,
    set(width, height) {
        console.trace(`${width}, ${height}`);
        this.width = width;
        this.height = height;
    }
})